{ doAction, fail, success } = require './index'
{ doFlash } = require './flash'

FAILED_CREATE_MESSAGE = 'Failed to create a new district'
SUCCEEDED_CREATE_MESSAGE = 'District created'
CREATED_DISTRICT = 'CREATED_DISTRICT'
CREATING_DISTRICT = 'CREATING_DISTRICT'

FAILED_DELETE_MESSAGE = 'Deletion failed'
SUCCEEDED_DELETE_MESSAGE = 'District deleted'
DELETED_DISTRICT = 'DELETED_DISTRICT'
DELETING_DISTRICT = 'DELETING_DISTRICT'

FAILED_FETCH_MESSAGE = 'Failed to retrieve the list of districts from the server'
FETCHED_DISTRICTS = 'FETCHED_DISTRICTS'
FETCHING_DISTRICTS = 'FETCHING_DISTRICTS'

SELECT_DISTRICT = 'SELECT_DISTRICT'

FAILED_UPDATE_MESSAGE = 'Update failed'
SUCCEEDED_UPDATE_MESSAGE = 'District updated'
UPDATED_DISTRICT = 'UPDATED_DISTRICT'
UPDATING_DISTRICT = 'UPDATING_DISTRICT'

module.exports = {
	FAILED_CREATE_MESSAGE
	CREATED_DISTRICT
	CREATING_DISTRICT

	FAILED_DELETE_MESSAGE
	DELETED_DISTRICT
	DELETING_DISTRICT

	FAILED_FETCH_MESSAGE
	FETCHED_DISTRICTS
	FETCHING_DISTRICTS

	SELECT_DISTRICT

	FAILED_UPDATE_MESSAGE
	UPDATED_DISTRICT
	UPDATING_DISTRICT

	createDistrict: (district) ->
		url = '/api/districts'
		method = 'post'
		payload = district
		doingActionType = CREATING_DISTRICT
		didActionType = CREATED_DISTRICT
		failureMessage = FAILED_CREATE_MESSAGE
		successMessage = SUCCEEDED_CREATE_MESSAGE
		doAction(url, method, payload, doingActionType, didActionType, failureMessage, successMessage)

	deleteDistrict: (districtId) ->
		url = '/api/districts/' + districtId
		method = 'delete'
		payload = { id: districtId }
		doingActionType = DELETING_DISTRICT
		didActionType = DELETED_DISTRICT
		failureMessage = FAILED_DELETE_MESSAGE
		successMessage = SUCCEEDED_DELETE_MESSAGE
		doAction(url, method, payload, doingActionType, didActionType, failureMessage, successMessage)

	fetchDistricts: ->
		url = '/api/districts'
		method = 'get'
		payload = null
		doingActionType = FETCHING_DISTRICTS
		didActionType = FETCHED_DISTRICTS
		failureMessage = FAILED_FETCH_MESSAGE
		doAction(url, method, payload, doingActionType, didActionType, failureMessage)

	selectDistrict: (district) ->
		type: SELECT_DISTRICT
		payload:
			district: district

	updateDistrict: (district) ->
		url = '/api/districts/' + district.id
		method = 'PATCH'
		payload = district
		doingActionType = UPDATING_DISTRICT
		didActionType = UPDATED_DISTRICT
		failureMessage = FAILED_UPDATE_MESSAGE
		successMessage = SUCCEEDED_UPDATE_MESSAGE
		doAction(url, method, payload, doingActionType, didActionType, failureMessage, successMessage)
}



// WEBPACK FOOTER //
// ./frontend/olos/js/actions/districts.coffee